import {
  Box,
  Typography
} from '@mui/material';
import PacksByTrustChart from './Components/Hospital/Outpatients/PacksByTrustChart';
import PacksByProductChart from './Components/Hospital/Outpatients/PacksByProductChart';
import UKHeatmap from './UKHeatmap';

function HospitalAIDashboard() {
  
  const backgroundGradient = '#FFFFFF';
  return (
    <Box sx={{ padding: 3, background: backgroundGradient, minHeight: '100vh' }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, mb: 3, color: 'text.primary',letterSpacing: '0.5px', }}>
            Hospital AI Dashboard
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <UKHeatmap height="700px" />
            {/* <PacksByTrustChart type='outpatients'/>
            <PacksByTrustChart type='inpatients'/>
            <PacksByProductChart /> */}
        </Box>
    </Box>
  );
}

export default HospitalAIDashboard;